import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormType } from '../Utilities/FormType';
import { AMIGForm, getShowedFields } from '../Utilities/AMIGForm';
import { damaged } from '../ScreenObjects/Residential/damaged';
import { setPathValue, setReduxValues, useAMIGFormik } from '../Utilities/AMIGHandleForm';
import { ComponentTitle,EMPTY_VALUE, phoneRegExp, states, zipCodeExp,StepTypes,FIELD_TYPE, IncidentOwnerTemplate } from '../../../../actions/types';
import { summaryActions } from "../../../../actions/summary";
import { newClaimActions } from "../../../../actions/newClaim";
import { useLoading } from '../../../../hooks/useLoading';
import { LoadingPlaceholder } from '../Utilities/LoadingPlaceholder';
import { Injured } from '../Common/Injured';
import CustomDialog from '../../../dialogs/CustomDialog';
import { updateClaim } from '../../../../actions/claimActions';
import * as Yup from 'yup';

const { updateDisabled } = summaryActions;
const { updateDamagedRes, updateInjured } = newClaimActions;

export const DamagedWithRedux = ({
  summary, 
  claim,
  newClaim,
  updateDisabled, 
  updateDamagedRes,
  updateInjured,
  updateClaim,
  stepType, 
  handleNext
}) => {
  
  const buildFields = () => {
    let properties = [];
    const riskUnits = claim.eventDetails.propertyIncidents
    if (riskUnits.length === 0) {
      return damaged;
    }else{
    riskUnits.map((element, index) => {
        properties.push(
          {
            value: `What was damaged at ${element.lossLocation.addressLine1}?`,
            name: `label_${element.lossLocation.id}`,
            type: FIELD_TYPE.CUSTOMLABEL,
            isOneColumn:true
          }, 
          {
             label: 'Home',
             name: `HOME_${element.lossLocation.id}`,
             initialValue: EMPTY_VALUE.CHECKBOX,
             type: FIELD_TYPE.CHECKBOX,
             tooltip: 'There was damage to the home, the dwelling itself and any structures attached to the dwelling.',
             yup: Yup.boolean()          
          },{
            label: 'Another person’s property',
            name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.CHECKBOX,
            type: FIELD_TYPE.CHECKBOX,
            tooltip: 'Situations where the insured is being held responsible for a dwelling or personal property that belongs to someone else that was damaged.',
            yup: Yup.boolean()
          },
          {
            label: 'Rental property',
            name: `RENTAL_PROPERTY_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.CHECKBOX,
            type: FIELD_TYPE.CHECKBOX,
            tooltip: 'Damage to a dwelling held for rental to a tenant.',
            yup: Yup.boolean()
          },
          {
            label: 'Someone was injured',
            name: `SOMEONE_INJURED_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.CHECKBOX,
            type: FIELD_TYPE.CHECKBOX,
            tooltip: 'No damage to the property itself, a claim needs to be filed for an injury.',
            keyPathToSaveValue: 'claim.eventDetails.isInjuredParties',
            yup: Yup.boolean()
          },
          {
            label: 'Belongings',
            name: `BELONGINGS_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.CHECKBOX,
            type: FIELD_TYPE.CHECKBOX,
            tooltip: 'Instances where a building or structure was not damaged, just the personal items, things you own.',
            isOneColumn: true,
            yup: Yup.boolean()
          },
          {
            label: 'Separate structures',
            name: `SEPARATE_STRUCTURE_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.CHECKBOX,
            type: FIELD_TYPE.CHECKBOX,
            tooltip: 'Structures on the insured property, but set apart from the dwelling by clear space.',
            isOneColumn: true,
            yup: Yup.boolean()
          },
          {
            label: 'No damage/ my power was out or I have to evacuate',
            name: `NO_DAMAGE_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.CHECKBOX,
            type: FIELD_TYPE.CHECKBOX,
            tooltip: 'If there is no physical damage to the home, but you need to submit a claim for additional living expenses because of evacuation, loss of food from power outage or other related event.',
            isOneColumn: true,
            yup: Yup.boolean()
          },
          {
            name: `information_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.POS_NEG,
            label: 'Do you have the contact information for the owner?',
            type: FIELD_TYPE.YES_NO,
            toHide: true,
            isOneColumn: true,
            dependencyFieldToShow: { name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true },
            keyPathToSaveValue: `claim.eventDetails.propertyIncidents[${index}].hasOwnerContact`,
            yup: Yup.mixed().when(`ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Select one').nullable(),
            }),
          },
          {
            name: `firstName_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'First Name',
            type: FIELD_TYPE.TEXT,
            col: 4,
            toHide: true,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide a first name').min(2, 'Too Short!').max(50, 'Too Long!'),
            }),
          },
          {
            name: `lastName_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'Last Name',
            type: FIELD_TYPE.TEXT,
            col: 4,
            toHide: true,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide a value').min(2, 'Too Short!').max(50, 'Too Long!'),
            }),
          },
          {
            name: `phone_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'Phone Number',
            type: FIELD_TYPE.TEL,
            col: 4,
            toHide: true,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide a phone').matches(phoneRegExp, 'Phone number is not valid, Format: 123-456-7890.'),
            }),
            inputProps: { maxLength: 12 },
          },
          {
            name: `addressLine1_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'Address 1',
            type: FIELD_TYPE.TEXT,
            toHide: true,
            col: 6,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide an address'),
            })
          },
          {
            name: `addressLine2_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'Address 2',
            type: FIELD_TYPE.TEXT,
            toHide: true,
            col: 6,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
          },
          {
            name: `city_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'City',
            type: FIELD_TYPE.TEXT,
            toHide: true,
            col: 4,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide a value'),
            })
          },
          {
            name: `state_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.SELECT,
            label: 'State',
            type: FIELD_TYPE.SELECT,
            options: states.map( option => {
              return { name: option.title , value: option.abbreviation.toUpperCase() };
            }),
            toHide: true,
            col: 4,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide a value'),
            }),
          },
          {
            name: `postalCode_${element.lossLocation.id}`,
            initialValue: EMPTY_VALUE.INPUT,
            label: 'Zip',
            type: FIELD_TYPE.TEXT,
            toHide: true,
            col: 4,
            dependencyFieldToShow: [{name: `ANOTHER_PERSONS_PROPERTY_${element.lossLocation.id}`, value: true},{name: `information_${element.lossLocation.id}`, value: true}],
            yup: Yup.string().when(`information_${element.lossLocation.id}`, {
              is: true,
              then: schema => schema.required('Provide a value').matches(zipCodeExp, 'Provide a valid Zip Code'),
            }),
          }, 
          {
            
            type: FIELD_TYPE.CUSTOMLINE,
            isOneColumn:true
          }) 
                 
        });
      }
        return [...properties];
    
  };

  
  const fields = buildFields();
  const [showInjured, setShowInjured] = useState(false);
  const {isLoading, setIsLoading} = useLoading();
  

  const handleSubmit = () => {
    const selectedDamageFields = fields.filter(field => field.type === FIELD_TYPE.CHECKBOX && formik.values[field.name] === true);
    
    const damageValues = selectedDamageFields.map(i => {
      return {name: i.name, value: formik.values[i.name]}
    });

    const ruleDamaged = damageValues.every( field => {

      if((field.name.includes('NO_DAMAGE')) && field.value) {
        return field.value;
      }
      return !field.value;
      
      });        
      
      const somOneDamagedValues = Object.keys(formik.values).filter((i) =>
         i.includes('SOMEONE_INJURED') 
      );
      var somOneDamaged = somOneDamagedValues.some((sv) => formik.values[sv]);
       
      const newValues = {...formik.values, ruleDamaged}

      
      updateDamagedRes(newValues);
    
    const showedFields = getShowedFields(formik, fields)
    const copyClaim = setPathValue(formik, showedFields, claim);
    copyClaim.damageType = fields.reduce((acc,cur) =>{
      if(cur.type === FIELD_TYPE.CHECKBOX && formik.values[cur.name]){ 
        return [...acc,cur.name];
      }
      return acc;
    },[]);

    let trimmedDamageType = [];
    let claimDamageType = [];
    copyClaim.eventDetails.propertyIncidents.map((element) => {
      if(trimmedDamageType.length > 0){
        trimmedDamageType = [];
      }
      let mapDamageType = copyClaim.damageType.filter(field => field.includes(`${element.lossLocation.id}`));
      mapDamageType.forEach((field) =>{
        var lastHyphenIndex = field.toString().lastIndexOf('_')
        var damageType_ext = (lastHyphenIndex != -1) ? field.toString().substring(0, lastHyphenIndex) : field
        trimmedDamageType.push(damageType_ext)
        claimDamageType.push(damageType_ext)
      });
      element.damageType = trimmedDamageType;
      if(element.hasOwnerContact != null || element.hasOwnerContact != undefined) {
        element.contacts.push({
          firstName: formik.values[`firstName_${element.lossLocation.id}`] || "unknown",
          lastName: formik.values[`lastName_${element.lossLocation.id}`] || "unknown",
          subtype: "Person",
          policyRole: "incidentowner",
          primaryPhoneType: "mobile",
          cellNumber: formik.values[`phone_${element.lossLocation.id}`] || "999-999-9999",
          primaryAddress: {
            addressLine1: formik.values[`addressLine1_${element.lossLocation.id}`] || "unknown",
            addressLine2: formik.values[`addressLine2_${element.lossLocation.id}`] || "",
            city: formik.values[`city_${element.lossLocation.id}`] || "Cincinnati",
            state: formik.values[`state_${element.lossLocation.id}`] || "OH",
            postalCode: formik.values[`postalCode_${element.lossLocation.id}`] ||"45201",
            country: formik.values[`country_${element.lossLocation.id}`] || "US"
          }
        });
      }

    if (formik.values[`NO_DAMAGE_${element.lossLocation.id}`]) copyClaim.lossCause = 'powerOutageEvacuation_ext';
    
    updateClaim(copyClaim);

    });
    
    if(claim.eventDetails.propertyIncidents.length>0){
      copyClaim.damageType = [];
      copyClaim.damageType= [...claimDamageType];
    }
    if(!somOneDamaged){
      setShowInjured(false);

      copyClaim.eventDetails.injuredParties = [];
      copyClaim.eventDetails.anyOneInjured = 'no';
      copyClaim.eventDetails.injuredPartiesCause = null;
      copyClaim.eventDetails.injuredPartiesCount = 0;
      copyClaim.eventDetails.isPolicyHolderInjured = null;
      copyClaim.eventDetails.isInjuredParties = false;
      copyClaim.eventDetails.hasInjuredPartiesContact = false;
     
      updateInjured( {
        "causeInjury": " ",
        "anyOneInjured": " ",
        "manyInjured": 0,
        "policyholder": "",
        "parties": ""
    } );

      const injuredToRemoveIndex = summary.disable.findIndex((step) => step.name === StepTypes.INJURED);
      if (injuredToRemoveIndex !== -1) { summary.disable.splice(injuredToRemoveIndex, 1);  }
            
  } 
   
  updateClaim(copyClaim);
    if(somOneDamaged){
        setShowInjured(true)
    }
    else if(!summary.isLastStept) handleNext();
    else updateDisabled(stepType, true);
  };
  
  const formik = useAMIGFormik(fields, handleSubmit);

  useEffect(() => {
    try {
        setReduxValues(formik, newClaim.damagedRes, fields);
        setIsLoading(false);
    } catch(error) {
      console.error("Error",error);
    }
  },[]);

  if(isLoading) return <LoadingPlaceholder />;

  return (
    <FormType
      title={(claim.eventDetails.propertyIncidents.length === 0) ? ComponentTitle.DAMAGED:''}
      subtitle='File a claim'
      buttonLabel={summary.isLastStept ? "Save" : "Continue"}
      isDisable={summary.isStepDisabled(summary.disable, stepType)}
      handleSubmit={formik.handleSubmit}>
      <AMIGForm stepType={stepType} fields={fields} formik={formik} />
      <CustomDialog
        title=''
        maxWidth='xl'
        open={showInjured}
        handleClose={() => setShowInjured(false)}>
        {<Injured stepType={StepTypes.INJURED} handleNext={handleNext}/>}
      </CustomDialog>
    </FormType>
  );
};

DamagedWithRedux.defaultProps = {
  stepType: StepTypes.DAMAGED_RES,
  handleNext: () => {},
};

const mapStateToProps = (state) => ({
  summary: state.summary,
  claim: state.claim,
  newClaim: state.newClaim,
});

export const DamagedResidential = connect(mapStateToProps, { updateInjured, updateDisabled, updateDamagedRes, updateClaim })(DamagedWithRedux);
